import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function ConfirmDialog({
  title,
  description,
  children,
  onConfirm,
  destructive,
  backLabel,
  confirmLabel,
}: {
  title: string
  description?: React.ReactNode
  children: React.ReactNode
  onConfirm: () => void
  destructive?: boolean
  backLabel?: string
  confirmLabel?: string
}) {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  const backLabelValue = backLabel || t('back')
  const confirmLabelValue = confirmLabel || t('confirm')

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <DialogFooter className="!justify-between">
          <Button
            variant="secondary"
            type="button"
            onClick={() => setOpen(false)}
          >
            {backLabelValue}
          </Button>
          <Button
            data-test-id="confirm-dialog-confirm"
            variant={destructive ? 'destructive' : 'default'}
            type="button"
            onClick={onConfirm}
          >
            {confirmLabelValue}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
